/**
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f,
 * and y is replaced with a random hexadecimal digit from 8 to b.
 * @author Jed
 * @url https://gist.github.com/jed/982883
 * @returns {String}
 */
function uuid() {
    var number = arguments[0];
    return number
        // eslint-disable-next-line no-bitwise
        ? (number ^ Math.random() * 16 >> number / 4).toString(16)
        // @ts-ignore
        : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
}

export { uuid };
